import { TResponsiveType } from '@features/responsive/typescript';
export const FLUID_SECTION_HORIZONTAL_PADDING = [{
  px: 16,
  ref: 375
},
// mobile (<480px)
{
  px: 24,
  ref: 480
},
// mobilelg (480–767px)
{
  px: 32,
  ref: 768
},
// tablet (768–1024px)
{
  px: 48,
  ref: 1025
},
// tabletlg (1025–1279px)
{
  px: 64,
  ref: 1280
},
// desktop (1280–1440px)
{
  px: 80,
  ref: 1920
} // widescreen (≥1441px)
] as const;

/**
 * Stałe px per breakpoint — bez 100vw / 100%.
 * Fluid calc (vw/%) w Chromium rozjeżdżał Swiper offset vs scrollbar/paginację.
 */
export const FLUID_SECTION_HORIZONTAL_PADDING_CSS = FLUID_SECTION_HORIZONTAL_PADDING.map(({
  px
}) => `0 ${px}px`);
export const FLUID_SECTION_HORIZONTAL_OFFSET_CSS = FLUID_SECTION_HORIZONTAL_PADDING.map(({
  px
}) => `${px}px`);
type FluidSectionPaddingValues = readonly [number, number, number, number, number, number];
export const getFluidSectionPaddingCss = (values: FluidSectionPaddingValues): string[] => values.map(px => `${px}px`);
const BREAKPOINT_INDEX: Record<TResponsiveType, number> = {
  mobile: 0,
  mobilelg: 1,
  tablet: 2,
  tabletlg: 3,
  desktop: 4,
  widescreen: 5,
  fullhd: 5,
  ultrahd: 5
};
export const getFluidSectionHorizontalPaddingIndex = (breakpoint: TResponsiveType): number => BREAKPOINT_INDEX[breakpoint] ?? 5;
export const getFluidSectionHorizontalPaddingPx = (breakpointIndex: number): number => {
  const {
    px
  } = FLUID_SECTION_HORIZONTAL_PADDING[breakpointIndex] ?? FLUID_SECTION_HORIZONTAL_PADDING[5];
  return px;
};